import { ActivatedRoute, Data, Route, Router, UrlTree } from '@angular/router';
import { NavigationInfo, Routing } from '../../../../routing';

export class ProfileSelectionComponentInfo {
  public static readonly ROUTE_PATH: string = 'select-profile';
  public static readonly ROUTE_MARKER_TAG: string = 'select-profile';
  private static readonly ERR_MSG_TEXT_PROFILE_NOT_FOUND: string = 'Profile not found';

  public static areProfilesSupported(router: Router): boolean {
    return Routing.findRoute(router.config, this.ROUTE_PATH, this.ROUTE_MARKER_TAG) ? true : false;
  }

  public static getProfileSelectionPageRoute(router: Router): Route {
    return Routing.findRoute(router.config, this.ROUTE_PATH, this.ROUTE_MARKER_TAG);
  }

  public static isCurrentPageProfileSelectionPage(router: Router): boolean {
    return Routing.doesCurrentPageMatchRoute(router, this.getProfileSelectionPageRoute(router));
  }

  public static createProfileSelectionPageNavigationInfo(
    router: Router,
    route: ActivatedRoute,
    forwardTo?: string
  ): NavigationInfo {
    const profileSelectionPageRoute: Route = Routing.findRoute(router.config, this.ROUTE_PATH, this.ROUTE_MARKER_TAG);
    if (!profileSelectionPageRoute) {
      throw new Error('Profile selection page route not found!');
    }

    let routeData: Data = undefined;

    if (forwardTo) {
      routeData = { ForwardTo: forwardTo };
    }

    return Routing.createNavigationInfo(profileSelectionPageRoute, route, routeData);
  }

  public static navigateToProfileSelectionPage(
    router: Router,
    route: ActivatedRoute,
    forwardTo?: string
  ): Promise<boolean> {
    const naviInfo: NavigationInfo = this.createProfileSelectionPageNavigationInfo(router, route, forwardTo);

    return router.navigate(naviInfo.Commands, naviInfo.Extras);
  }

  public static createProfileSelectionPageUrlTree(router: Router, route: ActivatedRoute, forwardTo?: string): UrlTree {
    const naviInfo: NavigationInfo = this.createProfileSelectionPageNavigationInfo(router, route, forwardTo);
    return router.createUrlTree(naviInfo.Commands, naviInfo.Extras);
  }

  public static hasProfileNotFoundMessage(err: any): boolean {
    if (err.message?.includes(this.ERR_MSG_TEXT_PROFILE_NOT_FOUND)) {
      return true;
    } else if (err.Message?.includes(this.ERR_MSG_TEXT_PROFILE_NOT_FOUND)) {
      return true;
    } else if (err.ExceptionMessage?.includes(this.ERR_MSG_TEXT_PROFILE_NOT_FOUND)) {
      return true;
    } else if (err.error && typeof err.error === 'object') {
      return this.hasProfileNotFoundMessage(err.error);
    } else if (err.InnerException && typeof err.InnerException === 'object') {
      return this.hasProfileNotFoundMessage(err.InnerException);
    } else {
      return false;
    }
  }
}
